module.exports = __webpack_public_path__ + "static/editionbjorlund-5097a37eeacb065244dad16c18922abf.png";